import React from 'react';
import {
  IonText,
  IonGrid,
  IonRow,
  IonCol,
  IonPage,
  IonContent
} from '@ionic/react';
import WithRecords from 'src/components/WithRecords';
import DefaultHeader from 'src/components/DefaultHeader';
import { secondsToTime, convert } from 'src/lib/time';
import { TotalsGraph, PerStageTypeGraph } from 'src/components/StatsGraphs';

// function percentChanged(oldNumber, newNumber) {
//   var decreaseValue = oldNumber - newNumber;
//   const percent = Math.round((decreaseValue / oldNumber) * 100);
//   return percent >= 0 ? `+${percent}%` : `${percent}%`;
// }

class Stats extends React.Component {
  render() {
    const {
      totals,
      per_stage_type,
      scheduled_time_diff
    } = this.props.resources;
    const start_diff = Object.values(scheduled_time_diff)[0];
    return (
      <IonPage>
        <DefaultHeader title="Job Stats" />
        <IonContent>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Worked Time:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              <IonText color="primary" className="strong">
                {secondsToTime(totals.work_time)}
              </IonText>
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Break Time:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              {secondsToTime(totals.break_time)}
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Total Time:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              {secondsToTime(totals.actual_time)}
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Orig Estimate:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              {/* {percentChanged(totals.actual_time, totals.original_estimate)} */}
              {secondsToTime(totals.original_estimate)}
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Adj Estimate:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              {/* {percentChanged(totals.actual_time, totals.adjusted_estimate)} */}
              {secondsToTime(totals.adjusted_estimate)}
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Scheduled Start:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              {start_diff <= 0
                ? convert(start_diff, 'minutes').toFixed() * -1 + ' mins early'
                : convert(start_diff, 'minutes').toFixed() + ' mins late'}
            </IonCol>
          </IonRow>
          <IonGrid className="mt-5">
            <div className="mb-5">
              <TotalsGraph totals={totals} />
            </div>
            <div className="mb-5">
              <PerStageTypeGraph perStageType={per_stage_type} />
            </div>
            {/* <div className="mb-5">
            <ScheduledTimeDiffGraph scheduledTimeDiff={scheduled_time_diff} />
          </div> */}
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}

export default (routerProps) => {
  return (
    <WithRecords
      useLifecycle={true}
      service="api/job-stats"
      defaultQuery={{
        _id: routerProps.match.params._id
      }}
      render={(withRecordsProps) => (
        <Stats {...withRecordsProps} {...routerProps} />
      )}
    />
  );
};
